import {
  makeStyles,
  tokens,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  finalUrlContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      columnGap: tokens.spacingHorizontalSNudge,
    },
  },
  copilotBanner: {
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalL,
  },
  finalUrlInput: {
    '> span.fui-Input': {
      minWidth: '100px',
    },
  },
});
